// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2788 ? "src_assets_js_front_construction-info" : chunkId) + ".bundle.js";
};